export default "__VITE_ASSET__0f6a2c4b__"